/*
 *   File : fund-order-detail.js
 *   Author : https://evoqins.com
 *   Description : Fund Order detail page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { Fragment, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

//Custom components
import { StatisticCard } from '../../Components/Card';
import { Chip } from '../../Components/Others';
import { Icon } from '../../Components/Icon';


//Style
import style from "../../Style/Component/order.module.scss";

const TIMELINE_DATA = [
    {
        label: "Order initiated",
        date: "23 Sep 2024"
    },
    {
        label: "Payment initiated from Federal Bank",
        date: "23 Sep 2024"
    },
    {
        label: "Order accepted",
        date: "23 Sep 2024"
    },
    {
        label: "Units allocated",
        date: "23 Sep 2024"
    },
];

const FundOrderDetail = () => {

    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                        <span className='text-decoration-hover-underline cursor-pointer'
                            onClick={() => navigate("/orders")}>Orders</span> / <span className='e-font-weight-600'>RA123457</span>
                    </p>
                </div>

                <div className='padding-52px-lr margin--80px-top'>
                    {/* Order summary */}
                    <div className={`${style.e_order_summary_wrapper} e-bg-american-violet border-radius-16 padding-32px-all`}>
                        <div className='d-flex align-items-center gap-12px '>
                            <div className={`${style.e_order_icon_wrapper} border-radius-8 e-bg-white py-2 padding-12px-lr w-max-content`}>
                                <img src={require("../../Assets/Image/Order/order-icon.png")}
                                    draggable={false}
                                    width={20}
                                    height={26}
                                    alt='order-icon' />
                            </div>
                            <h4 className='mb-0 e-text-white e-primary-font e-font-20 e-font-weight-600 line-height-24px'>
                                Bandhan Infrastructure Growth Plan
                            </h4>
                        </div>

                        {/* Statistic cards */}
                        <div className='row row-cols-6 row-gap-4 pt-4 mt-2'>
                            <div className='col'>
                                <StatisticCard title="Order ID"
                                    value="RA123456" />
                            </div>
                            <div className='col'>
                                <StatisticCard title="Executed on"
                                    value="12 Jun 2024" />
                            </div>
                            <div className='col'>
                                <StatisticCard title="Amount invested"
                                    value="₹5,02,345.87" />
                            </div>
                            <div className='col'>
                                <StatisticCard title="Type"
                                    value="SIP" />
                            </div>
                            <div className='col'>
                                <StatisticCard title="Order status"
                                    value={
                                        <Chip label="Success"
                                            className="e-bg-green-crayola padding-2px-tb" />
                                    } />
                            </div>
                            <div className='col'>
                                <StatisticCard title="Payment status"
                                    value={
                                        <Chip label="Success"
                                            className="e-bg-green-crayola" />
                                    } />
                            </div>
                        </div>
                    </div>

                    {/* Order timeline */}
                    <div className={`${style.e_order_detail_table_wrapper} padding-32px-all e-bg-ghost-white border-radius-16 margin-32px-top`}>
                        <h4 className='mb-4 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                            Order timeline
                        </h4>

                        <div className='row'>
                            <div className='col-6'>
                                <div className='e-bg-magnolia py-4 px-3 border-radius-8 e-border-1px-pale-lavender-extra-light'>
                                    {TIMELINE_DATA.map((data, key) => (
                                        <div className='d-flex gap-2 align-items-start'>
                                            <div className='d-flex flex-column  align-items-center'>
                                                <div>
                                                    <Icon icon="success"
                                                        size="1.25rem"
                                                        className="d-flex" />
                                                </div>
                                                {TIMELINE_DATA.length - 1 !== key &&
                                                    <div className='d-flex'>
                                                        <div className='vr e-bg-aero-blue h-56px w-1px'></div>
                                                    </div>
                                                }
                                            </div>
                                            <div>
                                                <p className='margin-2px-bottom e-text-davys-grey-light e-primary-font e-font-14 e-font-weight-400 line-height-22px'>
                                                    {data.label}
                                                </p>
                                                <p className='mb-0 e-text-dim-black e-primary-font e-font-14 e-font-weight-400 line-height-22px'>
                                                    {data.date}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default FundOrderDetail;
